module.exports = __webpack_public_path__ + "img/medication-btn.79ee126a.svg";